import { render, staticRenderFns } from "./Modal4.vue?vue&type=template&id=210a516d&scoped=true&"
import script from "./Modal4.vue?vue&type=script&lang=js&"
export * from "./Modal4.vue?vue&type=script&lang=js&"
import style0 from "./Modal4.vue?vue&type=style&index=0&id=210a516d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "210a516d",
  null
  
)

export default component.exports